import { SyntheticEvent, useContext, useEffect, useState } from "react";

import TableContext from "context/table/tableContext";

import Details from "./Details";
import Header from "./Header";
import OfflineLicenses from "./OfflineLicenses";
import TabSection from "./TabSection";
import { TABS } from "./types";

const LicenseDetails = () => {
    const {
        detailsData: { enabled }
    } = useContext(TableContext);

    const [tabValue, setTabValue] = useState(TABS.LicenseDetails);

    useEffect(() => {
        !enabled && setTabValue(TABS.LicenseDetails);
    }, [enabled]);

    const handleTabChange = (_: SyntheticEvent, newValue: TABS) =>
        setTabValue(newValue);

    const isDetailsTabSelected = tabValue === TABS.LicenseDetails;

    return (
        <>
            <Header isDetailsTabSelected={isDetailsTabSelected} />

            <TabSection
                tabValue={tabValue}
                isEnabled={enabled}
                handleTabChange={handleTabChange}
            />

            {isDetailsTabSelected ? <Details /> : <OfflineLicenses />}
        </>
    );
};

export default LicenseDetails;
